const breadCrumb = "Lançamento de Notas - Lançamento de Notas/Conceitos/Faltas";

const routes = [
  {
    path: "/consultar-resumo-de-lancamento-de-notas-conceitos/:id/:periodoId/turmas-abertas",
    name: "consultar-resumo-de-lancamento-de-notas-conceitos-turmas-abertas",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultarResumoDeLancamentoDeNotasConceitos/ConsultarResumoDeLancamentoDeNotasConceitosTurmasAbertas.vue"
      ),
  },
  {
    path: "/consultar-resumo-de-lancamento-de-notas-conceitos/:id/turmas-abertas/:turmaId",
    name: "consultar-resumo-de-lancamento-de-notas-conceitos-turmas-abertas-detalhe",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultarResumoDeLancamentoDeNotasConceitos/TurmasAbertas/DisciplinaAreaDoConhecimento.vue"
      ),
  },
  {
    path: "/consultar-resumo-de-lancamento-de-notas-conceitos/:id/turmas-abertas/:turmaId/alunos-sem-nota-zero/:resumoId",
    name: "consultar-resumo-de-lancamento-de-notas-conceitos-turmas-abertas-alunos-sem-nota-zero",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultarResumoDeLancamentoDeNotasConceitos/TurmasAbertas/AlunosSemNotaZero.vue"
      ),
  },
  {
    path: "/consultar-resumo-de-lancamento-de-notas-conceitos/:id/turmas-abertas/:turmaId/alunos-com-nota-zero/:resumoId",
    name: "consultar-resumo-de-lancamento-de-notas-conceitos-turmas-abertas-alunos-com-nota-zero",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultarResumoDeLancamentoDeNotasConceitos/TurmasAbertas/AlunosComNotaZero.vue"
      ),
  },
];

export default routes;
